import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/api"; // Import your axios instance

// Create an async thunk for the API call
export const fetchAssessments = createAsyncThunk(
  "assessments/fetchAssessments",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await api.get("/assessment/get_assessment_admin/", {
        params: queryParams, // Pass queryParams as the params for the API request
      }); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create an async thunk for the create assessment API call
export const createAssessments = createAsyncThunk(
  "assessments/createAssessments",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("/assessment/assessment/", data); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create an async thunk for the create assessment with AI API call
export const createAssessmentWithAI = createAsyncThunk(
  "assessments/createAssessmentWithAI",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/assessment/assessment_using_groq/",
        data
      ); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create an async thunk for the share assessment API call
export const shareAssessment = createAsyncThunk(
  "assessments/shareAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("/assessment/assessment_link/", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create an async thunk for the update assessment API call
export const updateAssessment = createAsyncThunk(
  "assessments/updateAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.put("/assessment/assessment/", data); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create an async thunk for the update assessment API call
export const deleteAssessment = createAsyncThunk(
  "assessments/deleteAssessment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.delete("/assessment/assessment/", {
        params: data,
      }); // Using your Axios instance for API call
      return { data: response.data, id: data?.assessment_id }; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create an async thunk for the add questions assessment API call
export const createQuestion = createAsyncThunk(
  "assessments/createQuestion",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("/assessment/question/", data); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create an async thunk for the add questions assessment API call
export const UpdateQuestion = createAsyncThunk(
  "assessments/UpdateQuestion",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.put("/assessment/question/", data); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Delete an async thunk for the add questions assessment API call
export const deleteQuestion = createAsyncThunk(
  "assessments/deleteQuestion",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.delete("/assessment/question/", {
        params: data,
      }); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create an async thunk for the delete choices assessment API call
export const deleteChoice = createAsyncThunk(
  "assessments/deleteChoice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.delete("/assessment/choice/", {
        params: data,
      }); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create an async thunk for the add questions assessment API call
export const createChoice = createAsyncThunk(
  "assessments/createChoice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post("/assessment/choice/", data, {
        headers: {
          "Content-Type": "multipart/form-data", // Axios will usually handle this for you
        },
      }); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Create an async thunk for the add questions assessment API call
export const updateChoice = createAsyncThunk(
  "assessments/updateChoice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.put("/assessment/choice/", data, {
        headers: {
          "Content-Type": "multipart/form-data", // Axios will usually handle this for you
        },
      }); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchAssessmentsExcel = createAsyncThunk(
  "assessments/fetchAssessmentsExcel",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/assessment/get_results_excel/", {
        responseType: "blob",
      });

      // Check if the response contains valid blob data
      if (response.data) {
        return response.data; // Return the blob data (Excel file) on success
      } else {
        throw new Error("No data returned from API");
      }
    } catch (error) {
      console.error("API Error:", error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
// Create an async thunk for the API call
export const fetchPublicAssessmentDetails = createAsyncThunk(
  "assessments/fetchPublicAssessmentDetails",
  async (queryParams, { rejectWithValue }) => {
    try {
      const response = await api.get("/assessment/get_assessment_info/", {
        params: queryParams, // Pass queryParams as the params for the API request
      }); // Using your Axios instance for API call
      return response.data; // Return the data on success
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Define the initial state of the slice
const initialState = {
  assessments: [],
  singleRecord: {},
  loading: false,
  error: null,
};

// Create the slice
const assessmentsSlice = createSlice({
  name: "assessments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssessments.pending, (state) => {
        state.loading = true; // Set loading to true when the API call is in progress
      })
      .addCase(fetchAssessments.fulfilled, (state, action) => {
        state.loading = false; // Set loading to false when API call is successful
        state.assessments = action.payload; // Store fetched users in state
      })
      .addCase(fetchAssessments.rejected, (state, action) => {
        state.loading = false; // Set loading to false when API call fails
        state.error = action.payload; // Store error in state
      })
      .addCase(deleteAssessment.pending, (state, action) => {
        state.loading = true; // Set loading to false when API call fails
      })
      .addCase(deleteAssessment.rejected, (state, action) => {
        state.loading = false; // Set loading to false when API call fails
        state.error = action.payload; // Store error in state
      })
      .addCase(deleteAssessment.fulfilled, (state, action) => {
        state.loading = false; // Set loading to false when API call fails
        state.assessments.data = state.assessments.data.filter(
          (assessment) => assessment.id !== action.payload.id
        );
      })
      .addCase(fetchAssessmentsExcel.pending, (state) => {
        state.loading = true; // Set loading to true when the API call is in progress
      })
      .addCase(fetchAssessmentsExcel.fulfilled, (state, action) => {
        state.loading = false; // Set loading to false when API call is successful
      })
      .addCase(fetchAssessmentsExcel.rejected, (state, action) => {
        state.loading = false; // Set loading to false when API call fails
        state.error = action.payload; // Store error in state
      })
      .addCase(fetchPublicAssessmentDetails.pending, (state) => {
        state.loading = true; // Set loading to true when the API call is in progress
      })
      .addCase(fetchPublicAssessmentDetails.fulfilled, (state, action) => {
        state.loading = false; // Set loading to false when API call is successful
        state.singleRecord = action.payload; // Store fetched users in state
      })
      .addCase(fetchPublicAssessmentDetails.rejected, (state, action) => {
        state.loading = false; // Set loading to false when API call fails
        state.error = action.payload; // Store error in state
      });
  },
});

export default assessmentsSlice.reducer;
